var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('button',{on:{"click":_vm.api}},[_vm._v("Api")]),_vm._v(" "),_c('button',{on:{"click":_vm.getUser}},[_vm._v("getUser")]),_vm._v(" "),_c('button',{on:{"click":_vm.userInfo}},[_vm._v("userInfo")]),_vm._v(" "),_c('button',{on:{"click":_vm.getTenant}},[_vm._v("getTenant")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b294bf7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 